import { useState, useEffect } from 'react';
import api from 'base/utils/api';
import { storage } from 'base/utils/localStorage';
import { STORAGE_SEARCH_SUGGEST_LIST } from 'base/config/constant';
import { useRouter } from 'next/router';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';

type IProps = {
    disableRequest?: boolean;
};

export type ISearchSuggestInstance = {
    onSearch: (value: string) => void;
    historyList: string[];
    hotList: string[];
    clearHistoryList: () => void;
    clearHistoryItem: (item: string) => void;
}

export default function useSearchSuggest(props?: IProps): ISearchSuggestInstance {
    const [historyList, setHistoryList] = useState<string[]>([])
    const [hotList, setHotList] = useState<string[]>([])
    const router = useRouter();
    const { disableRequest = false } = props || {};

    const getHistoryList = () => {
        try {
            const list = storage.get(STORAGE_SEARCH_SUGGEST_LIST);
            if (list) {
                setHistoryList(JSON.parse(list));
                return;
            }
        } catch (e) {
        }
        setHistoryList([]);
    }

    const updateHistoryList = (list: string[]) => {
        setHistoryList(list);
        if (list.length) {
            storage.set(STORAGE_SEARCH_SUGGEST_LIST, JSON.stringify(list))
        } else {
            storage.remove(STORAGE_SEARCH_SUGGEST_LIST);
        }
    }
    const clearHistoryList = () => updateHistoryList([]);

    const clearHistoryItem = (item: string) => {
        const list = [...historyList];
        list.splice(list.indexOf(item), 1);
        updateHistoryList(list);
    };

    const getHotList = async () => {
        const res = await api.get('/web/default-search-word')
        setHotList(res?.wordList || [])
    }

    const onSearch = (value: string) => {
        value = value.trim();
        if (!value) {
            return;
        }
        updateHistoryList(Array.from(new Set([value, ...historyList])));
        router.push(generatePath(RouteEnum.SEARCH, { q: value }));
    }

    useEffect(() => {
        if (!disableRequest) {
            getHistoryList()
            getHotList()
        }
    }, []);

    return {
        onSearch,
        historyList,
        hotList,
        clearHistoryList,
        clearHistoryItem
    }
}